import { TextField } from "@material-ui/core";
import { Button } from "antd";
import { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useCountry } from "../../provider/courtryProvider";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import config from "../../config";
import { MdAddCircleOutline } from "react-icons/md";
import { IoArrowBackSharp } from "react-icons/io5";
import { v4 } from "uuid";
import { useFooterData } from "../../provider/billingProviders/footerDataProvider";
import { useAccess } from "../../provider/AccessProvider";
import { GENERATEBILLACCESS } from "../../utils/constant";

const OtherChargesModal = ({ open = () => {}, onClose = () => {} }) => {
  const billLineSettings = useSelector((state) => state.settings.settings);
  const [toggleState, setToggleState] = useState(1);
  const country = useCountry();
  const shopDetails = useSelector((state) => state.shopDetails);
  const invoiceSettings = useSelector(
    (state) => state.newInvoicesettings.newInvoicesettings
  );
  const [chargesName, setChargesName] = useState("");
  const [newlyAddedCharges, setNewlyAddedCharges] = useState([]);
  const dispatch = useDispatch();
  const [otherChargeList, setOtherChargeList] = useState([]);
  const { footerData, setFooterData } = useFooterData();
  const [loading, setLoading] = useState(false);
  const toggleTab = (index) => {
    setToggleState(index);
  };

  const access = useAccess(GENERATEBILLACCESS);

  const handleSave = () => {
    alert("Save");
    setLoading(true);
    const newCharges = newlyAddedCharges.map((name) => {
      return {
        name: name,
        id: v4(),
        price: "",
      };
    });
    const updatedOtherCharges = [...otherChargeList, ...newCharges];
    console.log("updatedOtherCharges", updatedOtherCharges);
    updateSettings(updatedOtherCharges);
  };

  const updateSettings = async (updatedOtherCharges) => {
    //newlyadded
    let tempSet = { ...billLineSettings };
    tempSet.otherChargesField = updatedOtherCharges;
    //newlyadded
    return await Promise.all([
      fetch(`${config.newApiGateway}/tools/shopDetailsUpdate`, {
        method: "POST",
        body: JSON.stringify({
          userId: shopDetails.shopId,
          settings: tempSet,
          action: "settings",
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        dispatch({
          type: "SET_SETTINGS",
          payload: data.Attributes.settings,
        });
        setOtherChargeList(data.Attributes.settings.otherChargesField || []);
        return data;
      })
      .catch((err) => {
        console.error("update settings", err);
      })
      .finally(() => {
        setLoading(false);
        setChargesName("");
        setNewlyAddedCharges([]);
      });
  };

  const otherChargesMemo = useMemo(() => {
    return billLineSettings?.otherChargesField;
  }, [billLineSettings?.otherChargesField]);

  const otherChargesWithMemo = useMemo(() => {
    return footerData.otherCharges;
  }, [footerData.otherCharges]);

  useEffect(() => {
    const otherChargesList = otherChargesMemo;
    if (otherChargesList) {
      setOtherChargeList(otherChargesList || []);
    }
    if (otherChargesWithMemo?.length > 0) {
      setOtherChargeList(otherChargesWithMemo || []);
    }
  }, [otherChargesMemo, otherChargesWithMemo]);

  return (
    <Modal
      show={open}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={() => onClose(false)}
      backdrop="static"
    >
      <div style={{ paddingTop: "10px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingLeft: "20px",
            paddingRight: "20px",
          }}
        >
          {toggleState === 2 && (
            <div
              className={
                toggleState === 1
                  ? "B-tabs2 B-tabsButton2 B-active-tabs2"
                  : "B-tabs2 B-tabsButton2"
              }
              style={{ color: "#EF4667" }}
              onClick={() => {
                toggleTab(1);
                if (billLineSettings.gst === "") {
                  return alert("Please enter GST");
                } else if (billLineSettings.igst === "") {
                  return alert("Please select IGST");
                } else if (billLineSettings.cess === "") {
                  return alert("Please select CESS");
                } else if (billLineSettings.additionalcess === "") {
                  return alert("Please select Additional CESS");
                }

                toggleTab(1);
              }}
            >
              <span
                style={{
                  display: "flex",
                  gap: 4,
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <IoArrowBackSharp />
                <span>Back</span>
              </span>
            </div>
          )}

          {toggleState === 1 && (
            <div
              className={
                toggleState === 1
                  ? "B-tabs2 B-tabsButton2 B-active-tabs2"
                  : "B-tabs2 B-tabsButton2"
              }
              style={{ color: "#EF4667" }}
              onClick={() => {
                toggleTab(1);
              }}
            >
              Other Charges
            </div>
          )}

          <div>
            <div
              className={
                toggleState === 2
                  ? "B-tabs2 B-tabsButton2 B-active-tabs2"
                  : "B-tabs2 B-tabsButton2"
              }
              onClick={() => {
                toggleTab(2);
              }}
            >
              <div
                style={{
                  color: "white",
                  background: "#5194c6",
                  fontSize: "13px",
                  padding: "5px",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Add charge <MdAddCircleOutline />
              </div>
            </div>
          </div>
          {toggleState === 1 ? (
            <div
              style={{ color: "black", cursor: "pointer" }}
              onClick={() => {
                onClose();
              }}
            >
              x
            </div>
          ) : (
            <div
              style={{ color: "red", cursor: "pointer" }}
              onClick={() => {
                onClose();
              }}
            >
              x
            </div>
          )}
        </div>
        <div className="B-content-tabs" style={{ margin: "10px" }}>
          <div
            className={
              toggleState === 1 ? "B-content  B-active-content" : "B-content"
            }
          >
            <hr style={{ fontSize: "1px" }}></hr>
            <div
              style={{
                height: 250,
                overflowY: "auto",
                paddingTop: 10,
              }}
            >
              {invoiceSettings.othercharges &&
                otherChargeList?.map((data) => (
                  <div
                    className="rightBottomContainer-customcharge"
                    key={data.id}
                  >
                    <p>
                      {data.name.charAt(0).toUpperCase() + data.name.slice(1)}
                    </p>
                    <TextField
                      type="number"
                      placeholder={`${country.CurrencySymbol}0.00`}
                      value={data.price}
                      onChange={(event) => {
                        setOtherChargeList((prev) =>
                          prev.map((i) => {
                            if (i.id === data.id) {
                              return {
                                ...i,
                                price: event.target.value,
                              };
                            }
                            return i;
                          })
                        );
                      }}
                      style={{
                        height: 16,
                        width: 50,
                        marginTop: 1,
                        padding: 0,
                        textAlign: "left",
                      }}
                      inputProps={{
                        style: {
                          padding: 0,
                          fontSize: 13,
                          textAlign: "left",
                        },
                      }}
                    ></TextField>
                  </div>
                ))}
            </div>
            <div style={{ textAlign: "right" }}>
              <button
                className="otherChargesAddButton"
                onClick={() => {
                  setFooterData((prev) => ({
                    ...prev,
                    otherCharges: otherChargeList,
                  }));
                  onClose();
                }}
              >
                Add
              </button>
            </div>
          </div>
          <div
            className={
              toggleState === 2 ? "B-content  B-active-content" : "B-content"
            }
          >
            <hr style={{ fontSize: "1px" }}></hr>
            {invoiceSettings.othercharges && (
              <div style={{ marginLeft: "20px" }}>
                <div style={{ marginBottom: "10px", display: "flex" }}>
                  <input
                    placeholder="Enter charge name"
                    onChange={(e) => setChargesName(e.target.value)}
                    value={chargesName}
                  />
                  <Button
                    style={{ marginLeft: "3%", marginTop: -3 }}
                    size="sm"
                    onClick={() => {
                      if (chargesName === "") {
                        alert("Field should not be empty");
                        return;
                      }
                      if (newlyAddedCharges.includes(chargesName)) {
                        alert("Already exists");
                        return;
                      }
                      setNewlyAddedCharges((prev) => [...prev, chargesName]);
                      setChargesName("");
                    }}
                  >
                    Add
                  </Button>
                </div>

                <div
                  style={{
                    height: "210px",
                    overflowY: "auto",
                  }}
                >
                  {newlyAddedCharges.map((i, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          padding: "8px",
                          float: "left",
                          display: "flex",
                          flexWrap: "wrap",
                        }}
                      >
                        <div
                          style={{
                            border: "2px solid black",
                            padding: "2px 10px 2px 10px",
                            borderRadius: "17px",
                          }}
                        >
                          <label>{i}</label>
                          <HighlightOffIcon
                            style={{
                              marginLeft: "10px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setNewlyAddedCharges((prev) => {
                                return prev.filter((item) => item !== i);
                              });
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
                  {otherChargeList?.map((data) => (
                    <div
                      key={data.id}
                      style={{
                        padding: "8px",
                        float: "left",
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        style={{
                          border: "2px solid black",
                          padding: "2px 10px 2px 10px",
                          borderRadius: "17px",
                        }}
                      >
                        <label>{data.name}</label>
                        <HighlightOffIcon
                          style={{
                            marginLeft: "10px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setOtherChargeList((prev) => {
                              return prev.filter((i) => i.id !== data.id);
                            });
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "right",
                  }}
                >
                  <Button
                    ghost
                    style={{
                      lineHeight: 0,
                    }}
                    onClick={() => {
                      onClose();
                    }}
                    size="small"
                    type="primary"
                  >
                    <span
                      style={{
                        fontSize: 12,
                      }}
                    >
                      Cancel
                    </span>
                  </Button>
                  <Button
                    style={{
                      lineHeight: 0,
                    }}
                    size="small"
                    type="primary"
                    loading={loading}
                    onClick={handleSave}
                  >
                    Save
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default OtherChargesModal;
